$(document).ready(function(){

    let ajaxLockActive = false;
    let stepDiscountWrapper = $('div#step_discount_wrapper');
    let productSearchWrapper = $('div#product_search_wrapper', stepDiscountWrapper);
    let searchResultWrapper = $('div#step_discount_product_search_results', stepDiscountWrapper);
    let chosenProductWrapper = $('div#chosen_product_wrapper', stepDiscountWrapper);
    let selectedProductId = $('div#chosen_product_wrapper input#product_id', stepDiscountWrapper);
    let groupSelectionWrapper = $('div#group_selection_wrapper', stepDiscountWrapper);
    let groupSelect = $('select[name="group"]', stepDiscountWrapper);
    let discountTargetWrapper = $('div#step_discount_target_wrapper', stepDiscountWrapper);
    let stepsWrapper = $('div#step_discount_steps_wrapper', stepDiscountWrapper);
    let discountTypeSelect = $('select[name="step_discount_type"]', stepDiscountWrapper);
    let removeStepIcon = $('div#step_discount_steps_wrapper i.glyphicon-trash', stepDiscountWrapper);
    let stepLogicWrapper = $('div#step_discount_step_logic_wrapper', stepDiscountWrapper);
    let discountNameInput = $('input[name="discount_name"]', stepDiscountWrapper);
    let saveErrorMessage = $('span#save_error_message', stepDiscountWrapper);
    let saveButtonWrapper = $('div#step_discount_save_button_wrapper', stepDiscountWrapper);
    let form = $('div#step_discount_form_wrapper', stepDiscountWrapper);
    let deactivateButton = $('div#deactivate_discount', stepDiscountWrapper);
    let activateButton = $('div#activate_discount', stepDiscountWrapper);
    let listGroup = $('div#step_discount_list_wrapper div.list-group', stepDiscountWrapper);

    const searchKeyupDelay = 500; // Milliseconds
    const ajaxPathProductSearch = '/action/discount/product-search';
    const ajaxPathProductGroupSearch = '/action/discount/product-group-search';
    const ajaxPathGetStepDiscountStepHtml = '/action/discount/get-step-discount-step-html';
    const ajaxPathGetStepDiscountStepsTable = '/action/discount/get-step-discount-steps-table';
    const ajaxPathSaveStepDiscount = '/action/discount/save-step-discount';
    const ajaxPathGetStepDiscountForm = '/action/discount/get-step-discount-form';
    const ajaxPathDeactivateDiscount = '/action/discount/deactivate-discount';
    const ajaxPathActivateDiscount = '/action/discount/activate-discount';
    const ajaxPathGetListItems = '/action/discount/step-discount-list-items';

    // Activate tooltip
    activateTooltip();

    // Display or hide discount target selection, i.e product or group
    // Get table with correct steps, i.e with discount percent or new price inputs
    $(stepDiscountWrapper).on('change', 'select[name="step_discount_type"]', function(){
        updateDiscountTargetSelection($(this).val());
        getStepsTable();
    });

    // Display correct search form after changing the select list
    $(stepDiscountWrapper).on('change', 'input[name="discount_target"]', function(){
        onDiscountTargetSelected($(this).val());
    });

    // Display correct search form after changing the select list
    $(stepDiscountWrapper).on('click', 'input[name="display_deactivated"]', function(){
        refreshList();
    });

    $(stepDiscountWrapper).on('click','div#save_step_discount',function() {
        if (validateForm()) {
            saveDiscount();
        }
    });

    // Activate or deactivate discount
    $(stepDiscountWrapper).on('click','div#deactivate_discount',function() {
        changeStatus($('input[name="price_info_id"]', stepDiscountWrapper).val(), ajaxPathDeactivateDiscount);
    });
    $(stepDiscountWrapper).on('click','div#activate_discount',function() {
        changeStatus($('input[name="price_info_id"]', stepDiscountWrapper).val(), ajaxPathActivateDiscount);
    });

    // Click on a product, add product id to hidden input field and display selected product name
    $(stepDiscountWrapper).on('click','div#step_discount_product_search_results table td',function() {
        var parentTr = $(this).closest('tr');
        var productId = parentTr.attr('product_id');
        var productName = parentTr.attr('product_name');

        $('input[name="product_id"]').val(productId);
        searchResultWrapper.hide();
        chosenProductWrapper.show();
        productSearchWrapper.hide();

        // Display product name as alert message
        let alertContent = "<button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> " + productName;
        $('div#chosen_product_alert').html(alertContent);
    });

    // Click to add a new step
    $(stepDiscountWrapper).on('click','button#add_step_button',function() {
        addStep();
    });

    // Remove step
    $(stepDiscountWrapper).on('click', 'i.glyphicon-trash', function() {
        let tr = $(this).closest('tr');
        tr.remove();
    });

    /**
     * Keyup in product search, delay search until no more keyups for 500ms
     */
    $(stepDiscountWrapper).on('keyup', 'div#step_discount_wrapper input[name="step_discount_product_search_input"]', delay(function (e) {
        productSearch(this.value, e);
    }, searchKeyupDelay));

    // Click on "x" on the selected product, removes the product and displays the product search element
    $(stepDiscountWrapper).on('click','div#chosen_product_alert button.close',function() {
        removeSelectedProduct();
    });

    // Click on discount in the list of existing discounts
    $(stepDiscountWrapper).on('click', 'div#step_discount_list_wrapper a.list-group-item',function () {
        getForm($(this).attr('price_info_id') * 1);
        return false;
    });

    /*
     * Display or hide filter options
     */
    $(stepDiscountWrapper).on('click', 'span#filter_span_wrapper',function () {
        // Toggle the filters wrapper
        $('div#filter_options_wrapper').toggle();

        // Change class of the glyphicon (arrow right or down
        var arrow = $('span#filter_span_wrapper span.glyphicon');
        if ($(arrow).hasClass('glyphicon-chevron-right')) {
            // Switch to down arrow
            $(arrow).removeClass('glyphicon-chevron-right');
            $(arrow).addClass('glyphicon-chevron-down');
        } else {
            // Switch to down right
            $(arrow).removeClass('glyphicon-chevron-down');
            $(arrow).addClass('glyphicon-chevron-right');
        }
    });

    function getStepsTable() {
        let discountType;

        switch (discountTypeSelect.val()) {
            case '11':
                discountType = 'discount_percent';
                stepLogicWrapper.show();
                break;
            case '12':
                discountType = 'new_price_inc_vat';
                stepLogicWrapper.hide();
                break;
            default:
                stepsWrapper.hide();
                return;
        }

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'GET',
            url: ajaxPathGetStepDiscountStepsTable,
            data: {
                discount_type: discountType
            },
            dataType: 'json',
        }).success(function (data) {
            $('table', stepsWrapper).replaceWith(data.html);
            stepsWrapper.show();
        }).error(function () {
            // displaySaveErrorMessage();
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function addStep() {
        let discountType;

        switch (discountTypeSelect.val()) {
            case '11':
                discountType = 'discount_percent';
                break;
            case '12':
                discountType = 'new_price_inc_vat';
                break;
            default:
                displayAlertMessage('Det oppstod en feil!', 'Ukjent rabattype valgt', 'danger', stepDiscountWrapper);
                return;
        }

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'GET',
            url: ajaxPathGetStepDiscountStepHtml,
            data: {
                discount_type: discountType
            },
            dataType: 'json',
        }).success(function (data) {
            $('tr:last', stepsWrapper).before(data.html);

        }).error(function () {
            // displaySaveErrorMessage();
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function removeSelectedProduct() {
        selectedProductId.val('');
        chosenProductWrapper.hide();
        productSearchWrapper.show();
    }

    function productSearch(searchString, event) {
        if ($.trim(searchString) === '' || $.trim(searchString).length < 2) {
            searchResultWrapper.hide();
            return;
        }

        if (event.key === "Backspace") {
            return;
        }

        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;



        if (searchResultWrapper.is(':hidden')) {
            searchResultWrapper.show();
        }

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'GET',
            url: ajaxPathProductSearch,
            data: {
                search_string: searchString
            },
            dataType: 'json',
        }).success(function (data) {
            $('div#step_discount_product_search_results tbody').html(data.search_result_html);
        }).error(function () {
            displayAlertMessage('Det oppstod en feil!', 'Kunne ikke søke på product, vennligst last siden på nytt', 'danger', stepDiscountWrapper);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /**
     * Displays the search form matching the selected discount type
     * and hides other search forms if they are visible
     */
    function onDiscountTargetSelected(selectedValue){
        switch (selectedValue){
            case 'product':
                groupSelectionWrapper.hide();
                productSearchWrapper.show();
                saveButtonWrapper.show();

                // If a product had already been selected, display the selected product wrapper
                if (selectedProductId.val() !== '' && (selectedProductId.val() * 1) > 0) {
                    chosenProductWrapper.show();
                }
                break;
            case 'group':
                groupSelectionWrapper.show();
                productSearchWrapper.hide();
                chosenProductWrapper.hide();
                saveButtonWrapper.show();
                break;
            default:
                groupSelectionWrapper.hide();
                productSearchWrapper.hide();
                saveButtonWrapper.hide();
                break;
        }
    }

    /**
     * Displays or hides the target type, product or group radio buttons
     */
    function updateDiscountTargetSelection(selectedValue){
        switch (selectedValue){
            case '11': // Discount percent
            case '12': // New price inc vat
                // if (discountTargetWrapper.is(':hidden')) {
                    discountTargetWrapper.show();
                // }
                break;
            default:
                // None selected
                discountTargetWrapper.hide();
                break;
        }
    }

    /**
     * Adds error class to invalid fields and returns false if form is not valid
     *
     * @returns {boolean}
     */
    function validateForm() {

        let errorText = '';
        if ($.trim(discountNameInput.val()) === '') {
            discountNameInput.closest('.form-group').addClass('has-error');
            errorText += ' - Navn kan ikke være tomt<br />';
        }
        if (discountTypeSelect.val() === '-1') {
            discountTypeSelect.closest('.form-group').addClass('has-error');
            errorText += ' - Type rabatt må velges<br />';
        }
        if (getSelectedDiscountTarget() === 'group' && groupSelect.val() === '-1') {
            groupSelect.closest('.form-group').addClass('has-error');
            errorText += ' - Varegruppe må velges<br />';
        } else if (getSelectedDiscountTarget() === 'product' && selectedProductId.val() === '') {
            productSearchWrapper.addClass('has-error');
            errorText += ' - Vare må velges<br />';
        } else if (getSelectedDiscountTarget() !== 'group' && getSelectedDiscountTarget() !== 'product'){
            // Neither group or product is selected
            discountTargetWrapper.addClass('has-error');
            errorText += ' - Velg om rabatten skal gjelde for vare eller varegruppe<br />';
        }

        let stepCount = 0;
        $('tr', stepsWrapper).each(function() {
            if (!$('input.discount_amount', this).length) {
                // Ignore trs without input fields
                return;
            }

            let amount = $.trim($('input.discount_amount', this).val()).replace(',', '.');
            let value = $.trim($('input.discount_value', this).val()).replace(',', '.');

            if (isNaN(amount * 1) || isNaN(value * 1) || amount === '' || value === '') {
                $(this).addClass('has-error');
                errorText += ' - Trinnrabatt må ha numeriske verdier<br />';
            }
            stepCount++;
        });

        if (stepCount === 0) {
            errorText += ' - Legg til minst et trinn<br />';
        }

        if (errorText !== '') {
            saveErrorMessage.html(errorText);
            saveErrorMessage.removeClass('hidden');
            saveButtonWrapper.addClass('has-error');
            setTimeout(removeErrorNotificationsInForm, 3000);
            return false;
        }
        return true;
    }

    function getSelectedDiscountTarget() {
        return $('input:radio[name="discount_target"]:checked', stepDiscountWrapper).val();
    }

    function removeErrorNotificationsInForm() {
        $('.form-group', stepDiscountWrapper).each(function(){
            $(this).removeClass('has-error');
        });
        $('.control-group', stepDiscountWrapper).each(function(){
            $(this).removeClass('has-error');
        });
        $('tr', stepDiscountWrapper).each(function(){
            $(this).removeClass('has-error');
        });
        saveErrorMessage.addClass('hidden');
    }

    function saveDiscount() {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'POST',
            url: ajaxPathSaveStepDiscount,
            data: $('div.form-horizontal', stepDiscountWrapper).find('input, select').serialize(),
            dataType: 'json',
        }).success(function (data) {
            $('div#step_discount_product_search_results tbody').html(data.search_result_html);
            ajaxLockActive = false;
            refreshList();
            ajaxLockActive = false;
            getForm(0, true);
        }).error(function (data) {
            let message = $.parseJSON(data.responseText).error_message;
            displayInfoMessageModal(stepDiscountWrapper, 'Det oppstod en feil!', message, 'Lukk', 'error');
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /**
     *
     * @param priceInfoId int
     * @param includeSaveSuccessMessage boolean
     * @returns {boolean}
     */
    function getForm(priceInfoId, includeSaveSuccessMessage = false) {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'GET',
            url: ajaxPathGetStepDiscountForm,
            data: {
                price_info_id: priceInfoId
            },
            dataType: 'json',
        }).success(function (data) {
            form.replaceWith(data.html);

            if (includeSaveSuccessMessage) {
                displaySaveSuccessMessage();
            }

            updateSelectorsAfterRefreshOfForm();
            activateTooltip();
        }).error(function (data) {
            let message = $.parseJSON(data.responseText).error_message;
            displayInfoMessageModal(stepDiscountWrapper, 'Det oppstod en feil!', message, 'Lukk', 'error');
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /**
     *
     * @param priceInfoId int
     * @returns {boolean}
     */
    function refreshList() {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        let displayDeactivatedDiscounts = $('input[name="display_deactivated"]', stepDiscountWrapper).is(':checked')?'1':'0';

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'GET',
            url: ajaxPathGetListItems,
            data: {
                display_deactivated_discounts: displayDeactivatedDiscounts
            },
            dataType: 'json',
        }).success(function (data) {
            listGroup.html(data.html);
        }).error(function (data) {
            let message = $.parseJSON(data.responseText).error_message;
            displayInfoMessageModal(stepDiscountWrapper, 'Det oppstod en feil!', message, 'Lukk', 'error');
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function changeStatus(priceInfoId, ajaxPath) {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'POST',
            url: ajaxPath,
            data: {
                price_info_id: priceInfoId
            },
            dataType: 'json',
        }).success(function () {
            ajaxLockActive = false;
            getForm(priceInfoId);

            ajaxLockActive = false;
            refreshList();
        }).error(function (data) {
            let message = $.parseJSON(data.responseText).error_message;
            displayInfoMessageModal(stepDiscountWrapper, 'Det oppstod en feil!', message, 'Lukk', 'error');
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function displaySaveSuccessMessage() {
        let element = stepDiscountWrapper.find('.form-group').first();
        let successMessage = 'Du kan fortsette å lagre nye trinnrabatter';

        displayAlertMessage('Trinnrabatt lagret!', successMessage, 'success', element);
    }

    function activateTooltip() {
        $('[data-toggle="tooltip"]', stepDiscountWrapper).tooltip();
    }

    function updateSelectorsAfterRefreshOfForm() {
        productSearchWrapper = $('div#product_search_wrapper', stepDiscountWrapper);
        searchResultWrapper = $('div#step_discount_product_search_results', stepDiscountWrapper);
        chosenProductWrapper = $('div#chosen_product_wrapper', stepDiscountWrapper);
        selectedProductId = $('div#chosen_product_wrapper input#product_id', stepDiscountWrapper);
        groupSelectionWrapper = $('div#group_selection_wrapper', stepDiscountWrapper);
        groupSelect = $('select[name="group"]', stepDiscountWrapper);
        discountTargetWrapper = $('div#step_discount_target_wrapper', stepDiscountWrapper);
        stepsWrapper = $('div#step_discount_steps_wrapper', stepDiscountWrapper);
        discountTypeSelect = $('select[name="step_discount_type"]', stepDiscountWrapper);
        removeStepIcon = $('div#step_discount_steps_wrapper i.glyphicon-trash', stepDiscountWrapper);
        stepLogicWrapper = $('div#step_discount_step_logic_wrapper', stepDiscountWrapper);
        discountNameInput = $('input[name="discount_name"]', stepDiscountWrapper);
        saveErrorMessage = $('span#save_error_message', stepDiscountWrapper);
        saveButtonWrapper = $('div#step_discount_save_button_wrapper', stepDiscountWrapper);
        form = $('div#step_discount_form_wrapper', stepDiscountWrapper);
        listGroup = $('div#step_discount_list_wrapper div.list-group', stepDiscountWrapper);
    }

});